




















import Vue from 'vue'
import UiIcon from '@/components/UiIcon.vue'

export default Vue.extend({
  name: "PostYoutubes",
  props: {
    youtubes: Array,
    onDelete: Function,
    isEditable: Boolean
  },
  data(){
    return {
      tweet: null,
    }
  },
  computed: {},
  methods: {},
  components: {
    UiIcon,
  }
})
